__webpack_require__.p = "/Web6Client/";